import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu, Popup } from 'semantic-ui-react'

import { sendBillingInvoicePeppol } from 'actions/billing'

const MESSAGES = {
  sending: 'Sending on Peppol… (refresh to update)',
  sent: 'Sent on Peppol',
  not_configured: 'Peppol not configured in supplier config',
  no_enterprise_number: 'Customer has no VAT number or Peppol ID',
  customer_not_registered: 'Customer is not registered on Peppol',
  validation_failed: 'Peppol validation failed — retry',
  sending_timeout: 'Peppol sending timed out — retry',
  unexpected_failure: 'Peppol sending failed — retry'
}
const DISABLED = ['sending', 'sent', 'not_configured', 'no_enterprise_number']

class SendBillingInvoicePeppolItem extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.props.send(this.props.billingInvoice.id)
  }

  render () {
    const message = this.props.billingInvoice.sendPeppolWarning
    if (message === 'not_sendable') return null

    const disabled = DISABLED.includes(message)
    const header = message ? (MESSAGES[message] || message) : 'Send on Peppol'

    return (
      <Popup
        header={header}
        trigger={<Menu.Item disabled={disabled} onClick={disabled ? null : this.handleClick}>{this.icon(message)}</Menu.Item>}
      />
    )
  }

  icon (message) {
    if (!message || (DISABLED.includes(message) && message !== 'sent')) {
      return <Icon loading={message === 'sending'} name="react"/>
    }
    return (
      <Icon.Group>
        <Icon name="react"/>
        {message === 'sent'
          ? <Icon corner name="check circle" color="green"/>
          : <Icon corner name="times circle" color="red"/>}
      </Icon.Group>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  send: (id) => dispatch(sendBillingInvoicePeppol(id))
})

export default connect(null, mapDispatchToProps)(SendBillingInvoicePeppolItem)
